import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  SOCIAL_FETCH,
  SOCIAL_EDIT,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'social' })
export default class Social extends VuexModule {
  @Action
  FetchSocial() {
    return Vue.axios({
      url: BASE_URL + SOCIAL_FETCH,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const social = data.data;
          return social;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  EditSocial(params) {
    return Vue.axios({
      url: BASE_URL + SOCIAL_EDIT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }
}
